import { uiText } from '@/i18n/interface';
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDateToDDMMYYYY(dateString: string | null | undefined): string {
  if (!dateString) return uiText("N/A");

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return uiText("N/A");

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}
